import { render, staticRenderFns } from "./QuickbooksSysChargeId.vue?vue&type=template&id=2028918b&"
import script from "./QuickbooksSysChargeId.vue?vue&type=script&lang=js&"
export * from "./QuickbooksSysChargeId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuickbooksSysChargeId.vue"
export default component.exports